export default "__VITE_ASSET__BnkEoPbY__"